
export default [
    {
        path: 'employee',
        name: 'employee',
        meta: {
            name: '员工管理'
        },
        component: () => import(/* webpackChunkName: "employee" */'../views/employee/index.vue')
    }
]
